import { rootApi } from "../../api/rootApi";

export const mandatoryFieldsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        updateMandatoryFields: builder.mutation({
            query: (params) => {
                return {
                    method: "PUT",
                    url: `/tenant/mandatory_fields`,
                    headers: {
                        slug: params.tenant_id,
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                    },
                    body: params.body,
                };
            },
        }),
        getMandatoryFields: builder.mutation({
            query: (params) => {
                let url = `tenant/mandatory_fields`;

                if (params?.user_type) {
                    url +=
                        "/?" +
                        new URLSearchParams({
                            user_type: params?.user_type,
                        })?.toString();
                }

                return {
                    method: "GET",
                    url: url,
                    headers: {
                        slug: params?.tenant_id,
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params?.token,
                    },
                };
            },
        }),
    }),
});

export const {
    useUpdateMandatoryFieldsMutation,
    useGetMandatoryFieldsMutation,
} = mandatoryFieldsApi;
